var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mx-auto my-10 max-w-lg" }, [
    _c(
      "div",
      { staticClass: "bg-white overflow-hidden shadow rounded-lg mt-10" },
      [
        _vm._m(0),
        _vm._m(1),
        _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
          _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
            _c("div", { staticClass: "sm:flex sm:items-end sm:justify-end" }, [
              _c(
                "div",
                {
                  staticClass:
                    "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                },
                [
                  _c(
                    "span",
                    { staticClass: "inline-flex rounded-md shadow-sm" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                          attrs: { type: "button", disabled: _vm.isEnabling },
                          on: { click: _vm.enable }
                        },
                        [_vm._v(" Enable ")]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "border-b border-gray-200 px-4 py-5 sm:px-6" },
      [_c("h1", [_vm._v("Order notifications")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
      _c(
        "div",
        { staticClass: "mt-2 mb-6 max-w-xl text-sm leading-5 text-gray-500" },
        [
          _vm._v(
            " With this feature you could send your customers about order updates "
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }